<template>
  <article class="pagebody">
    <header v-if="title"><h1 class="h6plus" v-html="title"></h1></header>
    <section v-if="body" class="textbody h6plus" v-html="body" :class="{'nimbus-sans': fontStyle === 'sans-serif'}"></section>
    <slot></slot>
    <footer class="underline-links">
      <h2 class="pagebody__header h6plus" v-if="footHead" v-html="footHead"></h2>
      <section v-if="footBody" class="contact h7 nimbus-sans" v-html="footBody"></section>
      <credits v-if="showCredits" class="is-hidden-mobile"></credits>
    </footer>
  </article>
</template>

<script>
import Credits from 'src/components/Credits'
export default {
  name: 'PageBody',
  props: ['title', 'body', 'footHead', 'footBody', 'showCredits', 'fontStyle'],
  components: {
    Credits
  },
  data () {
    return {
      creditsVisible: false
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';

.pagebody {
  max-width:26.9375em;
  margin:0 auto;
  padding:4.375em $gutter*2 6.25em;
  box-sizing:content-box;

  > * {
    margin-bottom:5em;
    &:last-child{
      margin-bottom: 0;
    }
  }

  h1,h2,h3,h4,h5,h6,footer{
    margin: 5em auto;
  }

  .nimbus-sans{
    hyphens:auto;
    letter-spacing:letterspace(30);
  }

  .contact{
    p {
      margin-bottom: 1em;
      text-align: left;
    }
    // two column contact on desktop
    @media (min-width:$bkpt-mobile + 1) {
      display:flex;
      flex-wrap:wrap;
      justify-content:space-between;
      > *{
        width:100%;
      }
      p{
        width:46.403712297%;
      }
    }
  }
}

@include on_mobile () {
  .pagebody{
    > *, h1,h2,h3,h4,h5,h6,footer{
      margin: 3em auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PageBody.vue?8ce211f2